import clsx from 'clsx';
import React from 'react';

import styles from './Button.module.scss';

interface ButtonIconProps {
  className?: string;
  children?: React.ReactNode;
}

export const ButtonIcon: React.FC<ButtonIconProps> = ({ className = '', children = [] }) => (
  <div className={clsx(styles.buttonIcon, className)}>{children}</div>
);